module.exports = __webpack_public_path__ + "static/media/sort.2234d7e0.png";